import PixPage from 'screens/Pix/Pix';

export default PixPage;
